import React from "react";
import { TextField, InputAdornment, Button } from "@material-ui/core"
import { SearchOutlined } from "@material-ui/icons";

import "./style.css";

export default function SearchInputs({
  languages,
  handleChangeInput,
  onClick,
  onReset,
  onAdvClick,
  inputValue,
  vocabularies,
  curLang,
  searchFields,
  searchValue,
}) {


  return (
    <>
      <div className="search-inputs-container">
        <div className="search-inputfield-container">

          <TextField
            className="search-input-field"
            placeholder={vocabularies[curLang]['search']['searchInputPlaceholder']}
            onChange={handleChangeInput}
            InputProps={{
              value: inputValue ?? inputValue,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="search-btns">
          <Button className="search-btn" variant="contained" onClick={onClick} type="submit"
            disabled={!searchValue || searchValue.trim() === ""}>
            {vocabularies[curLang]['search']['btnText']}
          </Button>
        </div > 
        <div className="reset-btns">
          <Button className="reset-btn" variant="outline" onClick={onReset}>
            {vocabularies[curLang]['search']['resetText']}
          </Button>
        </div>
      </div>
    </>

  )
}
